'use client';

import * as React from 'react';
import { useAppCookieConsent } from 'app/app.quotion.co/[isEU]/app-cookie-consent';
import { AffonsoScript } from 'app/root/[isEU]/_components/affiliate';
import { isEnvDev } from 'utils';

export function AppAffiliate({ isEU }: { isEU: boolean }): JSX.Element {
  const { isAcceptedAll } = useAppCookieConsent();
  if (isEnvDev || (isEU && !isAcceptedAll)) {
    return <></>;
  }
  return <AffonsoScript />;
}
